<template>
	<div>
		<bita-breadcrumb :items="breadCrumbs" />
		<div class="wrapper wrapper-content animated fadeInRight">
			<bita-ibox :is-loading="isLoadingGrid">
				<div slot="body">
					<bita-bootbutton
						v-if="!showForm && $acl.can('create', 'promotions')"
						type="primary"
						title="حراج جدید"
						icon="fas fa-plus-square"
						btn-width="200px"
						@click.native="openModal"
					/>
					<hr />
					<bita-grid
						ref="grid"
						:columns="gridColumns"
						:read-data="readData"
						:auto-bind="false"
						:page-size="pageSize"
						:current-page="currentPage"
						:has-row-number="true"
					/>
				</div>
			</bita-ibox>
		</div>
		<form-modal
			ref="editModal"
			:isLoading="isLoadingModal"
			:props-roles="roles"
			:title="title"
			@on-create="onCreate"
			@on-update="onUpdate"
		/>
	</div>
</template>
<script>
import {
	promotionApi,
} from '@/api/apiManagement.js';
import PromotionsForm from './components/PromotionForm';

export default {
	components: { 'form-modal': PromotionsForm },
	data() {
		return {
			pageSize: 10,
			currentPage: 1,
			productId: null,
			breadCrumbs: [
				{ title: 'صفحه اصلی', link: '/' },
				{
					title: 'مدیریت حراج ها ',
					link: '/shop/promotions',
					active: true,
				},
			],
			roles: [],

			isLoadingGrid: false,
			isLoadingModal: false,
			showForm: false,
			productTemp: {},

			gridColumns: [
				{ field: 'title', title: 'عنوان' },
				{
					field: 'value',
					title: 'مقدار تخفیف',
					template: this.offerValueTemlate,
				},
				{ field: 'status', title: 'وضعیت', template: this.statusTemlate },
				{ title: 'عملیات', command: [] },
			],
		};
	},
	computed: {
		title() {
			let title = 'افزودن';
			if (this.$refs.editModal && this.$refs.editModal.getId())
				title = 'ویرایش';
			return title + ' حراج ';
		},
	},
	mounted() {
		this.loadData();
		this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
	},
	methods: {
		usedCountTemlate(e) {
			return (
				e.used_count +
				' / ' +
				(e.available_count == null ? '∞' : e.available_count)
			);
		},
		currency(amount, valueType) {
			let result = '';

			if (valueType == 1) result = amount + ' ' + '%';
			else result = this.$currencyLabel(amount);

			return result;
		},
		offerValueTemlate(e) {
			return this.$thousandSeprator(this.currency(e.value, e.value_type));
		},
		statusTemlate(e) {
			return e.status ? 'فعال' : 'غیر فعال';
		},
		onCreate(data) {
			this.isLoadingModal = true;

			promotionApi
				.createPromotion(this.$getFormData(data))
				.then((res) => {
					this.$izitoast('success', 'عملیات موفق', res.data.message);

					this.successForm();
				})
				.catch((err) => {
					this.$refs.editModal.setErrors(err.response.data.errors);
				})
				.finally(() => {
					this.isLoadingModal = false;
				});
		},
		successForm() {
			this.loadData();
			this.$refs.editModal.resetForm();

			this.$toggleModal('#edit-modal');
		},
		onUpdate(data) {
			this.isLoadingModal = true;

			promotionApi
				.updatePromotion(data.id, this.$getFormData(data))
				.then((res) => {
					this.$izitoast('success', 'عملیات موفق', res.data.message);

					this.successForm();
				})
				.catch((err) => {
					this.$refs.editModal.setErrors(err.response.data.errors);
				})
				.finally(() => {
					this.isLoadingModal = false;
				});
		},
		readData(e) {
			this.$resetGrid();
			this.isLoadingGrid = true;

			promotionApi
				.getPromotions()
				.then(({ data }) => {
					e.success(data.entity);
				})
				.catch(() => {
					e.success([]);
				})
				.finally(() => {
					this.isLoadingGrid = false;
				});
		},

		delete(e) {
			let data = this.$refs.grid.getSelectedGridRow(e);
			this.$alert(
				'question',
				`آیا از حذف حراج  ${data.title} اطمینان دارید ؟`,
				'',
				{
					confirmButtonText: 'بله',
				}
			).then((result) => {
				if (result.value) {
					this.isLoadingGrid = true;
					promotionApi
						.deletePromotion(data.id)
						.then((res) => {
							this.$izitoast('success', 'عملیات موفق', res.data.message);
							this.loadData();
						})
						.finally(() => {
							this.isLoadingGrid = false;
						});
				}
			});
		},
		loadData() {
			this.$refs.grid.loadDataSource();
		},
		gridCommands() {
			let commands = [];

			if (this.$acl.can('edit', 'promotions'))
				commands.push({
					text: 'edit',
					click: this.edit,
					template: this.gridButtons.edit,
				});
			commands.push({
				text: 'items',
				click: this.viewProducts,
				template: this.gridButtons.items,
			});
			if (this.$acl.can('delete', 'promotions'))
				commands.push({
					text: 'delete',
					click: this.delete,
					template: this.gridButtons.delete,
				});
			return commands;
		},
		openModal() {
			this.$toggleModal('#edit-modal');
		},
		edit(e) {
			let data = this.$refs.grid.getSelectedGridRow(e);

			this.isLoadingModal = true;
			this.openModal();
      setTimeout(() => {
        this.$refs.editModal.setForm(data);
        this.isLoadingModal = false;
      }, 1000);
		},
		viewProducts(e) {
			let data = this.$refs.grid.getSelectedGridRow(e);
			this.$router.push({
				name: 'promotionproducts',
				params: { promotionID: data.id },
			});
		},
	},
};
</script>
<style scoped>
.fade-enter {
	opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
	transition: all 1s ease-in;
}
.fade-leave {
	opacity: 0.2;
}
.badge {
	margin: 2px;
	font-size: 13px !important;
	font-weight: 800;
}
</style>
